<template>
  <div>
    <section>
      <LoadingWidget v-if="loading" />

      <template v-else>
        <v-container>
          <div class="item">
            <div
              class="item-images"
              :class="{ 'item-images-terrain': $route.name === 'Terreno' }"
            >
              <div
                @click="showGallery(0)"
                class="position-relative cursor-pointer item-img-container"
              >
                <img
                  class="d-block item-img"
                  :src="featuredImage"
                  width="100%"
                  height="100%"
                />

                <div
                  class="d-flex align-center justify-center item-img-content"
                >
                  <v-icon class="item-img-content-icon" color="white" size="45">
                    fa-search-plus
                  </v-icon>
                </div>
              </div>

              <template v-for="(img, keyGallery) in gallery">
                <div
                  :key="keyGallery"
                  @click="showGallery(keyGallery + 1)"
                  class="position-relative cursor-pointer item-img-container"
                >
                  <img
                    class="d-block item-img"
                    :src="img"
                    width="100%"
                    height="100%"
                  />

                  <div
                    class="d-flex align-center justify-center item-img-content"
                    :class="{
                      text:
                        images.length > 2 && keyGallery + 1 === gallery.length,
                    }"
                  >
                    <div
                      v-if="
                        images.length > 2 && keyGallery + 1 === gallery.length
                      "
                      class="
                        white--text
                        text-h6 text-md-h5 text-center
                        font-weight-bold
                      "
                    >
                      {{
                        `+ ${images.length - 2} Foto${
                          images.length - 2 > 1 ? "s" : ""
                        }`
                      }}
                    </div>

                    <v-icon
                      v-else
                      class="item-img-content-icon"
                      color="white"
                      size="45"
                    >
                      fa-search-plus
                    </v-icon>
                  </div>
                </div>
              </template>
            </div>

            <div class="align-start mt-8 mt-md-10 item-content">
              <div>
                <div
                  class="
                    d-flex
                    align-start
                    justify-space-between
                    flex-column flex-sm-row
                  "
                >
                  <v-sheet
                    v-if="xsOnly"
                    class="
                      primary--text
                      text-body-2
                      font-weight-medium
                      py-1
                      px-3
                      mt-1
                      item-reference
                    "
                    color="#F0E9EA"
                  >
                    Ref.: {{ item.reference }}
                  </v-sheet>

                  <div
                    class="
                      primary--text
                      text-h6 text-sm-h5 text-md-h4
                      font-weight-medium
                      mt-2 mt-sm-0
                    "
                  >
                    {{ title }}
                  </div>

                  <v-sheet
                    v-if="!xsOnly"
                    class="
                      primary--text
                      text-body-2
                      font-weight-medium
                      py-1
                      px-3
                      mt-1
                      ml-3
                      item-reference
                    "
                    color="#F0E9EA"
                  >
                    Ref.: {{ item.reference }}
                  </v-sheet>
                </div>

                <div v-if="item.price" class="mt-4 mt-md-6">
                  <div
                    class="
                      primary--text
                      text-caption text-sm-body-1
                      font-weight-regular
                    "
                  >
                    {{
                      item.category +
                      (item.business === "Venda"
                        ? " a venda por"
                        : " para locação por")
                    }}
                  </div>

                  <div
                    class="
                      primary--text
                      text-h6 text-md-h5
                      font-weight-regular
                      mt-sm-2
                    "
                  >
                    {{ formatPrice(item.price) }}
                  </div>
                </div>

                <div
                  v-if="featuresIcons.length"
                  class="d-flex align-center mt-4 mt-md-6 item-features-icons"
                >
                  <div
                    v-for="({ text, icon, size }, keyFeatures) in featuresIcons"
                    :key="keyFeatures"
                    class="d-flex align-center"
                  >
                    <v-icon color="primary" :size="size" left>
                      {{ icon }}
                    </v-icon>

                    <div class="text--primary text-body-2 font-weight-regular">
                      {{ text }}
                    </div>
                  </div>
                </div>

                <div v-if="item.features.length" class="mt-6">
                  <div
                    class="
                      primary--text
                      text-subtitle-1 text-sm-h6 text-md-h5
                      font-weight-bold
                    "
                  >
                    Características
                  </div>

                  <div class="mt-2 mt-md-3 item-features">
                    <template v-for="feature in item.features">
                      <div :key="feature" class="d-flex align-center">
                        <v-icon color="primary" :size="xsOnly ? 14 : 18" left>
                          fa-chevron-right
                        </v-icon>
                        <div
                          class="
                            primary--text
                            text-body-2 text-sm-body-1
                            font-weight-regular
                          "
                        >
                          {{ feature }}
                        </div>
                      </div>
                    </template>
                  </div>
                </div>

                <div v-if="item.infrastructures.length" class="mt-6">
                  <div
                    class="primary--text text-sm-h6 text-md-h5 font-weight-bold"
                  >
                    Infraestruturas
                  </div>

                  <div class="mt-2 mt-md-3 item-infrastructures">
                    <template v-for="infrastructure in item.infrastructures">
                      <div :key="infrastructure" class="d-flex align-center">
                        <v-icon color="primary" :size="xsOnly ? 14 : 18" left>
                          fa-chevron-right
                        </v-icon>
                        <div
                          class="
                            primary--text
                            text-body-2 text-sm-body-1
                            font-weight-regular
                          "
                        >
                          {{ infrastructure }}
                        </div>
                      </div>
                    </template>
                  </div>
                </div>

                <div v-if="item.text" class="mt-6">
                  <div
                    class="primary--text text-sm-h6 text-md-h5 font-weight-bold"
                  >
                    Descrição
                  </div>

                  <div
                    class="
                      primary--text
                      text-body-2 text-sm-body-1 text-justify
                      font-weight-regular
                      mt-2 mt-md-3
                      item-text
                      ck-content
                    "
                    v-html="parsedText"
                  ></div>
                </div>

                <div v-if="item.video" class="mt-4 mt-md-6 item-video">
                  <iframe
                    width="560"
                    height="315"
                    :src="'https://www.youtube.com/embed/' + item.video"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                  ></iframe>
                </div>

                <div
                  v-if="realtor && realtor.name"
                  class="d-flex mt-4 mt-md-6 item-realtor"
                >
                  <img
                    @error="errorImage"
                    class="
                      grey
                      lighten-2
                      d-block
                      rounded-circle
                      item-realtor-img
                    "
                    :src="realtor.img"
                  />

                  <div
                    class="
                      d-flex
                      flex-column
                      justify-center
                      ml-3 ml-md-5
                      item-realtor-content
                    "
                  >
                    <div
                      class="
                        primary--text
                        text-body-1
                        font-weight-medium
                        item-realtor-title
                      "
                    >
                      {{ realtor.name }}
                    </div>
                    <div
                      v-if="realtor.creci"
                      class="
                        primary--text
                        text-body-1
                        font-weight-regular font-italic
                        mt-1
                        item-realtor-subtitle
                      "
                    >
                      Creci: {{ realtor.creci }}
                    </div>

                    <v-btn
                      v-if="informations.whatsapp"
                      class="mt-3"
                      :href="whatsappLink"
                      target="_blank"
                      color="#66BB6A"
                      width="max-content"
                      depressed
                      tile
                    >
                      <v-icon color="white" size="20" left>
                        fab fa-whatsapp
                      </v-icon>
                      <div
                        class="
                          white--text
                          text-body-1 text-none
                          font-weight-medium
                        "
                      >
                        Fale com o Corretor
                      </div>
                    </v-btn>

                    <v-btn
                      v-else-if="item.realtor.phone"
                      class="mt-5"
                      color="primary lighten-1"
                      depressed
                      tile
                    >
                      <v-icon color="white" size="20" left>
                        fa-phone-alt
                      </v-icon>
                      <div
                        class="
                          white--text
                          text-body-1 text-none
                          font-weight-medium
                        "
                      >
                        {{ item.realtor.phone }}
                      </div>
                    </v-btn>
                  </div>
                </div>

                <div
                  class="
                    primary--text
                    text-body-2
                    font-weight-regular
                    mt-4 mt-md-6
                  "
                >
                  Este imóvel está sujeito a alterações sem prévio aviso.
                </div>
              </div>

              <v-sheet class="pa-8 pa-md-12" color="primary">
                <div class="white--text text-h6 text-md-h5 font-weight-bold">
                  Mais Informações
                </div>

                <PropertyContactForm />
              </v-sheet>
            </div>
          </div>
        </v-container>
      </template>
    </section>

    <RelatedsPropertiesSection
      v-if="item.price"
      :category="item.category"
      :business="item.business === 'Venda' ? 1 : 2"
      :price="item.price"
    />
  </div>
</template>

<script>
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import PropertyContactForm from "../components/forms/PropertyContactForm.vue";
import RelatedsPropertiesSection from "../components/sections/RelatedsPropertiesSection.vue";
import { getWhatsappLinkFromPhone } from "../utils/getWhatsappLinkFromPhone";
import { formatPrice } from "../utils/formatPrice";

const _config = {
  mod: "properties",
};

const _data = {
  loading: true,
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    item() {
      return this.$rest(_config.mod).item;
    },
    title() {
      const item = this.item;

      const category = item.category.split(" ").pop();
      const district = item.district.split(" ");
      let parsedDistrict = item.district;

      if (category == district[0])
        parsedDistrict = item.district.replace(category, "");

      return item.category + " | " + parsedDistrict;
    },
    images() {
      return [
        this.featuredImage,
        ...Object.values(this.item.gallery)
          .filter(({ Foto }) => Foto !== this.featuredImage)
          .map(({ Foto }) => {
            return Foto;
          }),
      ];
    },
    featuredImage() {
      return this.item.img;
    },
    featuresIcons() {
      const features = [];

      if (this.item.garage)
        features.push({
          text: this.item.garage,
          icon: "fa-car",
          size: 24,
        });

      if (this.item.bedrooms)
        features.push({
          text: this.item.bedrooms,
          icon: "fa-bed",
          size: 24,
        });

      if (this.item.area)
        features.push({
          text: this.item.area + "m²",
          icon: "fa-home",
          size: 22,
        });

      if (this.item.total_area)
        features.push({
          text: this.item.total_area + "m²",
          icon: "fa-expand-arrows-alt",
          size: 20,
        });

      return features;
    },
    gallery() {
      if (this.$route.name === "Terreno") return [];

      return this.images.slice(1, 3);
    },
    parsedText() {
      return this.item.text.replace(
        /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
        "$1" + "<br />" + "$2"
      );
    },
    realtor() {
      let realtor = null;
      const item = this.item;

      if (item.realtor && item.realtor.Nome)
        realtor = {
          name: item.realtor.Nome,
          img: item.realtor.Foto,
          tel: item.realtor.Celular,
          creci: item.realtor.CRECI ? parseFloat(item.realtor.CRECI) : "",
        };

      return realtor;
    },
    itemId() {
      return this.$route.params.item.split("-").pop();
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    whatsappLink() {
      return (
        getWhatsappLinkFromPhone(this.informations.whatsapp) +
        "?text=Olá, me interessei neste imóvel e quero falar com um corretor!%0A" +
        location.href
      );
    },
  },
  methods: {
    getItem() {
      this.loading = true;

      this.$rest(_config.mod)
        .get({ id: this.itemId })
        .catch(() => this.$router.replace("/erro404"))
        .finally(() => (this.loading = false));
    },
    showGallery(index) {
      window.showGalleryWidget(this.images, index);
    },
    errorImage(e) {
      const informations = this.informations;
      const DefaultImg = this.files + informations.icon;

      e.target.src = DefaultImg;
    },
    formatPrice,
  },
  watch: {
    itemId() {
      this.getItem();
    },
  },
  created() {
    this.getItem();
  },
  components: {
    LoadingWidget,
    PropertyContactForm,
    RelatedsPropertiesSection,
  },
};
</script>

<style lang="scss" scoped>
.item {
  &-images {
    display: grid;
    gap: 13px;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, 1fr);

    @media screen and (max-width: 959.9px) {
      gap: 2px;
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(3, 1fr);

      &.item-images-terrain {
        grid-template-rows: 1fr;
      }
    }

    .item-img-container {
      &:nth-child(1) {
        grid-area: 1 / 1 / 3 / 3;

        @media screen and (max-width: 959.9px) {
          grid-area: 1 / 1 / 3 / 3;
        }
      }

      &:nth-child(2) {
        grid-area: 1 / 3 / 2 / 4;

        @media screen and (max-width: 959.9px) {
          grid-area: 3 / 1 / 4 / 2;
        }
      }

      &:nth-child(3) {
        grid-area: 2 / 3 / 3 / 4;

        @media screen and (max-width: 959.9px) {
          grid-area: 3 / 2 / 4 / 3;
        }
      }

      .item-img {
        aspect-ratio: 880 / 570;
        object-fit: cover;
      }

      .item-img-content {
        background-color: rgba(0, 0, 0, 0);
        bottom: 0;
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
        transition: all 0.1s linear;

        &.text {
          background-color: rgba(0, 0, 0, 0.4);
        }

        &-icon {
          opacity: 0;
          transition: all 0.1s linear 0.1s;
        }
      }

      &:hover {
        .item-img-content {
          background-color: rgba(0, 0, 0, 0.2);

          &-icon {
            opacity: 0.6;
          }
        }
      }
    }
  }

  &-content {
    display: grid;
    gap: 24px;
    grid-template-columns: 1fr 420px;

    @media screen and (max-width: 959.9px) {
      grid-template-columns: 1fr;
    }
  }

  &-reference {
    border: 1px solid #d6d0d1 !important;
    white-space: nowrap;
  }

  .item-video::v-deep {
    aspect-ratio: 16 / 9;
    object-fit: contain;
    width: 70%;

    iframe {
      display: block !important;
      height: 100% !important;
      width: 100% !important;
    }
  }

  &-realtor {
    &-img {
      aspect-ratio: 1;
      object-fit: cover;
      width: 130px;
    }
  }

  &-features {
    display: grid;
    grid-template-columns: repeat(2, calc(50% - 12px));
    gap: 12px;
  }

  &-infrastructures {
    display: grid;
    grid-template-columns: repeat(2, calc(50% - 12px));
    gap: 12px;
  }

  &-features-icons {
    gap: 24px;
  }
}
</style>
